/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Tools_Muted_HintInputs */



/**
* | output |
* | --- |
* | "You switched this connection off on your integrations page, so linking it yields no tools." |
*
* @param {Project_References_Tools_Muted_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_tools_muted_hint = /** @type {((inputs?: Project_References_Tools_Muted_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Tools_Muted_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben diese Verbindung auf Ihrer Integrationsseite deaktiviert, eine Verknüpfung liefert keine Werkzeuge.")
	return /** @type {LocalizedString} */ ("You switched this connection off on your integrations page, so linking it yields no tools.")
});